export interface StepperStep {
  key: string;
  label: string;
}

interface StepperProps {
  steps: StepperStep[];
  currentKey: string;
}

/** Horizontal progress indicator for the 5-screen onboarding (OnboardingLayout.tsx). Wraps on mobile instead of scrolling horizontally. */
export function Stepper({ steps, currentKey }: StepperProps) {
  const currentIndex = steps.findIndex((step) => step.key === currentKey);

  return (
    <ol className="flex w-full flex-wrap items-center gap-x-1 gap-y-3" aria-label="Progresso do cadastro">
      {steps.map((step, index) => {
        const isCurrent = step.key === currentKey;
        const isDone = currentIndex >= 0 && index < currentIndex;

        return (
          <li key={step.key} className="flex items-center">
            <span
              aria-current={isCurrent ? 'step' : undefined}
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-pill border font-mono text-xs font-medium ${
                isCurrent
                  ? 'border-primary bg-primary text-primary-foreground'
                  : isDone
                    ? 'border-primary text-primary'
                    : 'border-border text-muted-foreground'
              }`}
            >
              {index + 1}
            </span>
            <span
              className={`ml-2 hidden text-xs font-medium sm:inline ${isCurrent ? 'text-foreground' : 'text-muted-foreground'}`}
            >
              {step.label}
            </span>
            {index < steps.length - 1 && (
              <span aria-hidden="true" className="mx-2 h-px w-4 shrink-0 bg-border sm:w-8" />
            )}
          </li>
        );
      })}
    </ol>
  );
}
